import Reflux from 'reflux';
import InvitationDetailActions from 'actions/InvitationDetail';
import SteelCompass from 'services/SteelCompass';
// import { normalize, Schema, arrayOf } from 'normalizr';

import { normalize, Schema, arrayOf } from 'normalizr';
const invitation = new Schema('invitation');

const InvitationDetailStore = Reflux.createStore({
  listenables: [InvitationDetailActions],
  data: {
    courseId: null,
    invitations: {
      pageStart: 0,
      pageLength: 25,
      loading: true
    },
    list: {
      invitations: []
    },
    entities: {
      invitation: {}
    },
    totalInvitations: 0
  },
  getInitialState() {
    return this.data;
  },
  read(courseId) {
    this.data = {
      ...this.data,
      courseId
    };
    const { pageStart, pageLength } = this.data.invitations;
    this.getInvitationsAtPage(0);
  },
  getInvitationsAtPage(pageStart) {
    const { pageLength } = this.data.invitations;
    if (pageStart + pageLength < this.data.list.invitations.length) {
      this.data = {
        ...this.data,
        invitations: {
          ...this.data.invitations,
          pageStart
        }
      };
      this.trigger(this.data);
      return;
    }
    const { courseId } = this.data;
    this.data = {
      ...this.data,
      invitations: {
        ...this.data.invitations,
        loading: true
      }
    };
    this.trigger(this.data);
    return SteelCompass.request(
      'invitation',
      'findByCourseId',
      { courseId, unusedOnly: 1, sortBy: 'name', sortMode: 'asc' },
      pageStart,
      pageLength
    ).then(response => {
      const data = normalize(response, arrayOf(invitation));
      const { entities } = this.data;
      const invitations =
        pageStart === 0
          ? data.result
          : this.data.list.invitations.concat(data.result);
      this.data = {
        ...this.data,
        invitations: {
          ...this.data.invitations,
          pageStart,
          loading: false
        },
        entities: {
          ...entities,
          invitation: {
            ...entities.invitation,
            ...data.entities.invitation
          }
        },
        list: {
          ...this.data.list,
          invitations
        }
      };
      this.trigger(this.data);
    });
  },
  nextInvitations() {
    this.getInvitationsAtPage(
      this.data.invitations.pageStart + this.data.invitations.pageLength
    );
  },
  prevInvitations() {
    if (this.data.invitations.pageStart >= this.data.invitations.pageLength) {
      this.getInvitationsAtPage(
        this.data.invitations.pageStart - this.data.invitations.pageLength
      );
    }
  },
  countInvitations(courseId) {
    return SteelCompass.call(
      'invitation',
      'countByCourseId',
      { courseId, unusedOnly: 1 },
      response => {
        this.data.totalInvitations = response.data;
        this.trigger(this.data);
      }
    );
  }
});

export default InvitationDetailStore;



// WEBPACK FOOTER //
// ./src/js/stores/InvitationDetail.js